import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

import { Lightbox } from "react-modal-image"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeRequiredimgdmg extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  required_img_dmg_id: "",
                  required_img_dmg_name: "",
                  selectedFielddamagefile: "",
                  selectedTherapycontractConditionsCovarage: "",
                  selectedTimeanswer_complaints: "",
                  selectedCustomer_satisfaction: "",
                  selectedNum_branchesdamages: "",

                  required_img_dmg_desc: "",
                  required_img_dmg_sample: "",
                  required_tum_img_dmg_sample: "",
                  orderBy: "required_img_dmg_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newRequiredimgdmg: true,
                  picturesRequestReady: "",
                  loading: false,
                  percent: 0,
                  optionTherapycontractConditionsCovarage: [],
                  optionFielddamagefile: [],
                  required_img_dmg_force: "0",

                  urlToLargeImageFile: "",
                  urlToHugeImageFile: "",
                  descImageFile: "",
                  openImageBox: false,
                  openDialog: false,
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      setImageModel = (image, largimage, desc) => {
            this.setState({
                  urlToLargeImageFile: largimage,
                  urlToHugeImageFile: image,
                  descImageFile: desc,
                  openImageBox: true,
            })
      }

      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }

      handleChangeRequiredimgdmgName = (event) => {
            this.setState({ required_img_dmg_name: event.target.value })
      }

      onSelectPicRequest = (picture) => {
            this.setState({
                  picturesRequestReady: picture[0],
            })
      }

      handleChangeRequiredimgdmgDesc = (event) => {
            this.setState({ required_img_dmg_desc: event.target.value })
      }

      handleTherapycontractConditionsCovarage = (selectedTherapycontractConditionsCovarage) => {
            this.setState({ selectedTherapycontractConditionsCovarage: selectedTherapycontractConditionsCovarage }, () => {
            })
      }

      handleFielddamagefile = (selectedFielddamagefile) => {
            this.setState({ selectedFielddamagefile: selectedFielddamagefile }, () => {
                  //this.filterManagDiscount()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ required_img_dmg_force: "1" })
            } else {
                  this.setState({ required_img_dmg_force: "0" })
            }
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        required_img_dmg_id: row2.required_img_dmg_id,
                        required_img_dmg_name: row2.required_img_dmg_name,
                        selectedTherapycontractConditionsCovarage: { value: row2.organ_therapycontract_conditions_covarage_id, label: row2.organ_therapycontract_conditions_covarage_name },
                        selectedFielddamagefile: { value: row2.required_img_fielddamagefile_id, label: row2.fielddamagefile_fa },
                        required_img_dmg_desc: row2.required_img_dmg_desc,
                        required_img_dmg_sample: row2.required_img_dmg_sample,
                        required_tum_img_dmg_sample: row2.required_tum_img_dmg_sample,
                        required_img_dmg_force: row2.required_img_dmg_force,
                        newRequiredimgdmg: false,
                  },
                  () => {}
            )
      }

      newRequiredimgdmg = (event) => {
            this.setState(
                  {
                        required_img_dmg_id: "",
                        required_img_dmg_name: "",
                        //  selectedFielddamagefile:optionFielddamagefile[0],
                        required_img_dmg_force: "0",
                        TherapycontractConditionsCovarage: "",
                        required_img_dmg_desc: "",
                        required_img_dmg_sample: "",
                        required_tum_img_dmg_sample: "",
                        newRequiredimgdmg: true,
                  },
                  () => {}
            )
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.getRequiredimgdmg()
                                    self.getoptionFielddamagefile()
                                    self.getoptionTherapycontractConditionsCovarage()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getoptionTherapycontractConditionsCovarage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].organ_therapycontract_conditions_covarage_id, label: arr.data[k].organ_therapycontract_conditions_covarage_name })
                              }
                              self.setState({ optionTherapycontractConditionsCovarage: Company, selectedTherapycontractConditionsCovarage: Company[0] }, () => {
                                 //   self.filterManagDiscount()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_organ_therapycontract_conditions_covarage")
            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.send(fd)
      }

      getoptionFielddamagefile = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].fielddamagefile_id, label: arr.data[k].fielddamagefile_fa })
                              }
                              self.setState({ optionFielddamagefile: Company, selectedFielddamagefile: Company[0] }, () => {
                                //    self.filterManagDiscount()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fielddamagefile")
            xhttp.open("POST", `${constants.BASE_URL}/fielddamagefile`)
            xhttp.send(fd)
      }

      getRequiredimgdmg() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                  //  self.filterManagDiscount()
                                    self.newRequiredimgdmg()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_requiredimgdmg")

            xhttp.open("POST", `${constants.BASE_URL}/requiredimgdmg`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewRequiredimgdmg = (imageCode) => {
            const { required_img_dmg_id, required_img_dmg_name, selectedFielddamagefile, selectedTherapycontractConditionsCovarage, required_img_dmg_desc, required_img_dmg_force } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getRequiredimgdmg()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "add_requiredimgdmg")
            fd.append("required_img_dmg_name", required_img_dmg_name)
            fd.append("required_img_fielddamagefile_id", selectedFielddamagefile.value)
            fd.append("required_img_dmg_organ_therapycontract_conditions_covarage_id", selectedTherapycontractConditionsCovarage.value)
            fd.append("required_img_dmg_desc", required_img_dmg_desc)
            fd.append("required_img_dmg_sample", imageCode)
            fd.append("required_img_dmg_force", required_img_dmg_force)
            xhttp.open("POST", `${constants.BASE_URL}/requiredimgdmg`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeRequiredimgdmg = (imageCode) => {
            const { required_img_dmg_id, required_img_dmg_name, selectedFielddamagefile, selectedTherapycontractConditionsCovarage, required_img_dmg_desc, required_img_dmg_force } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getRequiredimgdmg()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_requiredimgdmg")
            fd.append("required_img_dmg_id", required_img_dmg_id)
            fd.append("required_img_dmg_name", required_img_dmg_name)
            fd.append("required_img_fielddamagefile_id", selectedFielddamagefile.value)
            fd.append("required_img_dmg_organ_therapycontract_conditions_covarage_id", selectedTherapycontractConditionsCovarage.value)
            fd.append("required_img_dmg_desc", required_img_dmg_desc)
            fd.append("required_img_dmg_force", required_img_dmg_force)
            if (imageCode !== "") {
                  fd.append("required_img_dmg_sample", imageCode)
            }

            xhttp.open("POST", `${constants.BASE_URL}/requiredimgdmg`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteImageRequire = () => {
            const { required_img_dmg_id } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getRequiredimgdmg()
                              self.newRequiredimgdmg()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_requiredimgdmg")
            fd.append("required_img_dmg_id", required_img_dmg_id)

            xhttp.open("POST", `${constants.BASE_URL}/requiredimgdmg`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      uploadPicDelivery = (mode) => {
            const { picturesRequestReady, required_img_dmg_name, selectedFielddamagefile, required_img_dmg_desc } = this.state
            if (required_img_dmg_desc != "" && required_img_dmg_name != "" && selectedFielddamagefile != "") {
                  if (picturesRequestReady && picturesRequestReady !== "" && picturesRequestReady !== null) {
                        this.setState({
                              loading: true,
                              percent: 0,
                        })

                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function() {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    console.log(arr)
                                    if (arr.result === "ok") {
                                          self.setState({
                                                loading: false,
                                                percent: 0,
                                          })
                                          if (mode === "new") {
                                                self.saveNewRequiredimgdmg(arr.data["image_code"])
                                          } else {
                                                self.changeRequiredimgdmg(arr.data["image_code"])
                                          }
                                    } else if (arr.result === "error") {
                                    }
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "uploadpic")
                        fd.append("image", picturesRequestReady)
                        fd.append("image_name", " تصویر عکس مورد نیاز" + required_img_dmg_name)
                        fd.append("image_desc", "تصویر عکس مورد نیاز " + required_img_dmg_name)
                        fd.append("name", "")
                        xhttp.upload.addEventListener(
                              "progress",
                              function(evt) {
                                    if (evt.lengthComputable) {
                                          var percentComplete = evt.loaded / evt.total
                                          self.setState({
                                                percent: percentComplete * 100,
                                          })
                                    }
                              },
                              false
                        )
                        xhttp.open("POST", `${constants.BASE_URL}/image`)
                        xhttp.send(fd)
                  } else {
                        console.log(mode)
                        if (mode === "new") {
                              this.saveNewRequiredimgdmg("")
                        } else {
                              this.changeRequiredimgdmg("")
                        }
                  }
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      filterManagDiscount = () => {
            const { selectedFielddamagefile, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (temparray[i].required_img_fielddamagefile_id === selectedFielddamagefile.value) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  urlToHugeImageFile,
                  required_img_dmg_force,
                  descImageFile,
                  urlToLargeImageFile,
                  optionTherapycontractConditionsCovarage,
                  selectedTherapycontractConditionsCovarage,
                  optionFielddamagefile,
                  selectedFielddamagefile,
                  loading,
                  percent,
                  selectedNum_branchesdamages,
                  selectedCustomer_satisfaction,
                  agentPermision,
                  snackMode,
                  snackstr,
                  showSnack,
                  newRequiredimgdmg,
                  required_img_dmg_id,
                  required_img_dmg_name,
                  required_img_dmg_sample,
                  required_tum_img_dmg_sample,
                  required_img_dmg_desc,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"آی دی عکس" + required_img_dmg_id}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img
                                                                              alt=""
                                                                              className={classes.large}
                                                                              src={required_tum_img_dmg_sample}
                                                                              onClick={() => {
                                                                                    this.setImageModel(
                                                                                          required_tum_img_dmg_sample,
                                                                                          required_img_dmg_sample,
                                                                                          required_img_dmg_name
                                                                                    )
                                                                              }}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نام عکس"
                                                                        handleInputt={this.handleChangeRequiredimgdmgName}
                                                                        value={required_img_dmg_name}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">{"فیلد خسارت بیمه"} </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"فیلد خسارت بیمه"}
                                                                              value={selectedFielddamagefile}
                                                                              onChange={this.handleFielddamagefile}
                                                                              options={optionFielddamagefile}
                                                                        />
                                                                  </div>
                                                            </Grid>


                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">{"زیر گروه"} </label>
                                                                        <Select
                                                                            isSearchable={true}
                                                                            className="adapter-txtsize"
                                                                            placeholder={"فیلد خسارت بیمه"}
                                                                            value={selectedTherapycontractConditionsCovarage}
                                                                            onChange={this.handleTherapycontractConditionsCovarage}
                                                                            options={optionTherapycontractConditionsCovarage}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={required_img_dmg_force === "1" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="اجباری بودن عکس"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="توضیحات عکس"
                                                                        handleInputt={this.handleChangeRequiredimgdmgDesc}
                                                                        value={required_img_dmg_desc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <ImageUploader
                                                                        withIcon={true}
                                                                        buttonText="عکس را انتخاب نمایید"
                                                                        onChange={this.onSelectPicRequest}
                                                                        withPreview="true"
                                                                        singleImage="true"
                                                                        imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                        maxFileSize={5242880}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  {loading && <LinearProgress variant="determinate" value={percent} />}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newRequiredimgdmg ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.uploadPicDelivery("new")
                                                                              }}
                                                                        >
                                                                              {"ثبت عکس جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newRequiredimgdmg}
                                                                              >
                                                                                    {"عکس جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.uploadPicDelivery("modify")
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>

                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {"حذف عکس مورد نیاز "}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell></TableCell>

                                                                              <TableCell
                                                                                    key={"fielddamagefile_fa"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "fielddamagefile_fa" ? order : false}
                                                                              >
                                                                                    {"نام فیلد خسارت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fielddamagefile_fa"}
                                                                                          direction={orderBy === "fielddamagefile_fa" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fielddamagefile_fa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"fielddamagefile_fa"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 20 }}
                                                                                  sortDirection={orderBy === "fielddamagefile_fa" ? order : false}
                                                                              >
                                                                                    {"زیر گروه"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "organ_therapycontract_conditions_covarage_id"}
                                                                                        direction={orderBy === "organ_therapycontract_conditions_covarage_id" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("organ_therapycontract_conditions_covarage_id")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>


                                                                              <TableCell
                                                                                    key={"required_img_dmg_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نام عکس"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "required_img_dmg_name"}
                                                                                          direction={
                                                                                                orderBy === "required_img_dmg_name" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("required_img_dmg_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"required_img_dmg_desc"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" توضیحات عکس"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "required_img_dmg_desc"}
                                                                                          direction={
                                                                                                orderBy === "required_img_dmg_desc" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("required_img_dmg_desc")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"required_img_dmg_force"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"اجباری بودن عکس"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "required_img_dmg_force"}
                                                                                          direction={
                                                                                                orderBy === "required_img_dmg_force" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("required_img_dmg_force")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["required_img_dmg_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell>
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt=""
                                                                                                            src={row["required_tum_img_dmg_sample"]}
                                                                                                      />
                                                                                                </TableCell>
                                                                                                <TableCell key={"fielddamagefile_fa"} align={"center"}>
                                                                                                      {row["fielddamagefile_fa"]}
                                                                                                </TableCell>
                                                                                                <TableCell key={"organ_therapycontract_conditions_covarage_id"} align={"center"}>
                                                                                                      {row["organ_therapycontract_conditions_covarage_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"required_img_dmg_name"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["required_img_dmg_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"required_img_dmg_desc"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["required_img_dmg_desc"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"required_img_dmg_force"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["required_img_dmg_force"] === "0" ||
                                                                                                      row["required_img_dmg_force"] === 0 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}

                              {this.state.openImageBox && (
                                    <Lightbox
                                          medium={urlToLargeImageFile}
                                          large={urlToHugeImageFile}
                                          alt={descImageFile}
                                          onClose={this.closeLightbox}
                                          showRotate={true}
                                          hideZoom={false}
                                    />
                              )}

                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید عکس مورد نیاز را پاک نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deleteImageRequire} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeRequiredimgdmg)
